import React, { useState } from 'react';
import { Select, SelectOption } from '../../components/Select';
import './SelectSandbox.css';

// Opções fixas para demonstração
const STATUS_OPTIONS: SelectOption[] = [
    { value: 'ativo', label: 'Ativo' },
    { value: 'inativo', label: 'Inativo' },
    { value: 'pendente', label: 'Pendente' },
    { value: 'cancelado', label: 'Cancelado' },
];

const ESTRUTURA_OPTIONS: SelectOption[] = [
    { value: '1', label: 'Fibrocimento' },
    { value: '2', label: 'Cerâmico' },
    { value: '3', label: 'Metálico' },
    { value: '4', label: 'Laje' },
    { value: '5', label: 'Solo' },
];

const MANY_OPTIONS: SelectOption[] = Array.from({ length: 50 }, (_, i) => ({
    value: i + 1,
    label: `Opção ${i + 1} - Descrição longa para testar overflow`,
}));

export default function SelectSandbox() {
    // Estados para cada variação
    const [singleValue, setSingleValue] = useState<string | number | null>(null);
    const [multipleValue, setMultipleValue] = useState<(string | number)[]>([]);
    const [remoteValue, setRemoteValue] = useState<string | number | null>(null);
    const [remoteMultiValue, setRemoteMultiValue] = useState<(string | number)[]>([]);
    const [noSearchValue, setNoSearchValue] = useState<string | number | null>(null);
    const [smallValue, setSmallValue] = useState<string | number | null>(null);
    const [largeValue, setLargeValue] = useState<string | number | null>(null);
    const [manyValue, setManyValue] = useState<(string | number)[]>([]);

    return (
        <div className="sandbox-container">
            <h1>Select Component Sandbox</h1>
            <p className="sandbox-description">
                Página de testes para o componente Select em suas diversas variações.
            </p>

            <div className="sandbox-grid">
                {/* 1. Seleção Única Básica */}
                <div className="sandbox-card">
                    <h3>1. Seleção Única (Básico)</h3>
                    <p>Lista fixa, seleção única, com busca.</p>
                    <Select
                        options={STATUS_OPTIONS}
                        value={singleValue}
                        onChange={(v) => setSingleValue(v as string | number | null)}
                        placeholder="Selecione um status..."
                    />
                    <div className="sandbox-value">
                        <strong>Valor:</strong> {JSON.stringify(singleValue)}
                    </div>
                </div>

                {/* 2. Seleção Múltipla */}
                <div className="sandbox-card">
                    <h3>2. Seleção Múltipla</h3>
                    <p>Lista fixa, múltipla seleção, com tags.</p>
                    <Select
                        options={ESTRUTURA_OPTIONS}
                        value={multipleValue}
                        onChange={(v) => setMultipleValue(v as (string | number)[])}
                        multiple
                        placeholder="Selecione estruturas..."
                    />
                    <div className="sandbox-value">
                        <strong>Valor:</strong> {JSON.stringify(multipleValue)}
                    </div>
                </div>

                {/* 3. Busca Remota (Vendedores) */}
                <div className="sandbox-card">
                    <h3>3. Busca Remota - Vendedores</h3>
                    <p>Busca no backend via rota de grid.</p>
                    <Select
                        remote={{
                            router: 'vendedor',
                            valueField: 'id',
                            labelField: 'nome',
                        }}
                        value={remoteValue}
                        onChange={(v) => setRemoteValue(v as string | number | null)}
                        placeholder="Buscar vendedor..."
                        searchPlaceholder="Digite para buscar..."
                    />
                    <div className="sandbox-value">
                        <strong>Valor:</strong> {JSON.stringify(remoteValue)}
                    </div>
                </div>

                {/* 4. Busca Remota Múltipla (Clientes) */}
                <div className="sandbox-card">
                    <h3>4. Busca Remota Múltipla - Clientes</h3>
                    <p>Busca no backend, seleção múltipla.</p>
                    <Select
                        remote={{
                            router: 'cliente',
                            valueField: 'id',
                            labelField: 'nome',
                        }}
                        value={remoteMultiValue}
                        onChange={(v) => setRemoteMultiValue(v as (string | number)[])}
                        multiple
                        placeholder="Buscar clientes..."
                    />
                    <div className="sandbox-value">
                        <strong>Valor:</strong> {JSON.stringify(remoteMultiValue)}
                    </div>
                </div>

                {/* 5. Sem Busca */}
                <div className="sandbox-card">
                    <h3>5. Sem Campo de Busca</h3>
                    <p>Lista fixa pequena, sem busca.</p>
                    <Select
                        options={STATUS_OPTIONS}
                        value={noSearchValue}
                        onChange={(v) => setNoSearchValue(v as string | number | null)}
                        searchable={false}
                        placeholder="Selecione..."
                    />
                    <div className="sandbox-value">
                        <strong>Valor:</strong> {JSON.stringify(noSearchValue)}
                    </div>
                </div>

                {/* 6. Tamanho Pequeno */}
                <div className="sandbox-card">
                    <h3>6. Tamanho Pequeno (sm)</h3>
                    <p>Componente compacto para filtros.</p>
                    <Select
                        options={STATUS_OPTIONS}
                        value={smallValue}
                        onChange={(v) => setSmallValue(v as string | number | null)}
                        size="sm"
                        placeholder="Filtrar..."
                    />
                    <div className="sandbox-value">
                        <strong>Valor:</strong> {JSON.stringify(smallValue)}
                    </div>
                </div>

                {/* 7. Tamanho Grande */}
                <div className="sandbox-card">
                    <h3>7. Tamanho Grande (lg)</h3>
                    <p>Componente maior para formulários.</p>
                    <Select
                        options={STATUS_OPTIONS}
                        value={largeValue}
                        onChange={(v) => setLargeValue(v as string | number | null)}
                        size="lg"
                        placeholder="Selecione um status..."
                    />
                    <div className="sandbox-value">
                        <strong>Valor:</strong> {JSON.stringify(largeValue)}
                    </div>
                </div>

                {/* 8. Muitas Opções */}
                <div className="sandbox-card">
                    <h3>8. Muitas Opções (50 itens)</h3>
                    <p>Lista grande com scroll e busca.</p>
                    <Select
                        options={MANY_OPTIONS}
                        value={manyValue}
                        onChange={(v) => setManyValue(v as (string | number)[])}
                        multiple
                        placeholder="Selecione várias..."
                        showSelectedCount
                    />
                    <div className="sandbox-value">
                        <strong>Valor:</strong> {JSON.stringify(manyValue)}
                    </div>
                </div>

                {/* 9. Desabilitado */}
                <div className="sandbox-card">
                    <h3>9. Desabilitado</h3>
                    <p>Componente em estado desabilitado.</p>
                    <Select
                        options={STATUS_OPTIONS}
                        value="ativo"
                        disabled
                        placeholder="Selecione..."
                    />
                </div>

                {/* 10. Não Limpável */}
                <div className="sandbox-card">
                    <h3>10. Sem Botão Limpar</h3>
                    <p>Campo obrigatório, sem opção de limpar.</p>
                    <Select
                        options={STATUS_OPTIONS}
                        value="pendente"
                        clearable={false}
                        placeholder="Selecione..."
                    />
                </div>
            </div>

            <hr />

            <h2>Documentação Rápida</h2>
            <div className="sandbox-docs">
                <h3>Props Principais</h3>
                <table className="sandbox-table">
                    <thead>
                        <tr>
                            <th>Prop</th>
                            <th>Tipo</th>
                            <th>Default</th>
                            <th>Descrição</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><code>options</code></td>
                            <td><code>SelectOption[]</code></td>
                            <td><code>[]</code></td>
                            <td>Lista fixa de opções</td>
                        </tr>
                        <tr>
                            <td><code>remote</code></td>
                            <td><code>{`{ router, valueField, labelField }`}</code></td>
                            <td>-</td>
                            <td>Configuração para busca no backend</td>
                        </tr>
                        <tr>
                            <td><code>value</code></td>
                            <td><code>string | number | array</code></td>
                            <td>-</td>
                            <td>Valor selecionado</td>
                        </tr>
                        <tr>
                            <td><code>onChange</code></td>
                            <td><code>(value, options) =&gt; void</code></td>
                            <td>-</td>
                            <td>Callback ao mudar valor</td>
                        </tr>
                        <tr>
                            <td><code>multiple</code></td>
                            <td><code>boolean</code></td>
                            <td><code>false</code></td>
                            <td>Permite seleção múltipla</td>
                        </tr>
                        <tr>
                            <td><code>searchable</code></td>
                            <td><code>boolean</code></td>
                            <td><code>true</code></td>
                            <td>Mostra campo de busca</td>
                        </tr>
                        <tr>
                            <td><code>clearable</code></td>
                            <td><code>boolean</code></td>
                            <td><code>true</code></td>
                            <td>Permite limpar seleção</td>
                        </tr>
                        <tr>
                            <td><code>size</code></td>
                            <td><code>'sm' | 'md' | 'lg'</code></td>
                            <td><code>'md'</code></td>
                            <td>Tamanho do componente</td>
                        </tr>
                        <tr>
                            <td><code>autoApply</code></td>
                            <td><code>boolean</code></td>
                            <td><code>true</code></td>
                            <td>Aplica ao selecionar (útil para filtros)</td>
                        </tr>
                    </tbody>
                </table>

                <h3>Exemplos de Uso</h3>
                <pre className="sandbox-code">{`// Lista fixa simples
<Select
    options={[
        { value: '1', label: 'Opção 1' },
        { value: '2', label: 'Opção 2' },
    ]}
    value={value}
    onChange={setValue}
/>

// Busca remota (backend)
<Select
    remote={{
        router: 'vendedor',
        valueField: 'id',
        labelField: 'nome',
    }}
    value={value}
    onChange={setValue}
/>

// Seleção múltipla
<Select
    options={options}
    value={values}
    onChange={setValues}
    multiple
/>`}</pre>
            </div>
        </div>
    );
}
